<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="orderProductShortTermRentalJoins" [lazy]="true" class="order-product-wrapper" (onLazyLoad)="loadLazy($event)" dataKey="orderProductShortTermRentalJoinId" selectionMode="single"
  [(selection)]="orderProductShortTermRentalJoin" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h3 style="float: left;margin: 6px;">Order Product ShortTermRental Join</h3>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Order Product ShortTerm Rental Join +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Order Product ShortTermRental Join +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': '110px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'OrderProductVO.name', 'in')"></th>
        <th [ngStyle]="{'width': '180px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.propertyCode', 'in')"></th>
        <th [ngStyle]="{'width': '120px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.bedrooms', 'in')"></th>
        <th [ngStyle]="{'width': '120px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.addressCounty', 'in')"></th>
        <th [ngStyle]="{'width': '90px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'valueAMT', 'in')"></th>
        <th [ngStyle]="{'width': '90px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'valuePCT', 'in')"></th>
        <th [ngStyle]="{'width': '130px'}">
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="feeTypes" appendTo="body"
            (onChange)="pt.filter($event.value, 'feeType', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': '130px'}">
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="feeFrequencies" appendTo="body"
            (onChange)="pt.filter($event.value, 'feeFrequency', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': '130px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addToRate', 'in')"></th>
        <th [ngStyle]="{'width': '180px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'showToCustomer', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-orderProductShortTermRentalJoin>
    <tr [pSelectableRow]="orderProductShortTermRentalJoin">
      <td>{{orderProductShortTermRentalJoin?.orderProduct.name}} </td>
      <td>{{orderProductShortTermRentalJoin?.propertyCode}}</td>
      <td>{{orderProductShortTermRentalJoin?.bedroomNum}}</td>
      <td>{{orderProductShortTermRentalJoin?.adrCounty}}</td>
      <td>{{orderProductShortTermRentalJoin?.valueAMT}}</td>
      <td>{{orderProductShortTermRentalJoin?.valuePCT}}</td>
      <td>{{getFeeType(orderProductShortTermRentalJoin)}}</td>
      <td>{{getFeeFrequencies(orderProductShortTermRentalJoin)}}</td>
      <td>{{orderProductShortTermRentalJoin?.addToRate}}</td>
      <td>{{orderProductShortTermRentalJoin?.showToCustomer}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(orderProductShortTermRentalJoin)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>